import { POS_ROUTE } from "../../constants/constants";

export const MARKETING_COUPON_CODES_ROUTE = POS_ROUTE + "/marketing/coupons"
export const MARKETING_CAMPAIGNS_ROUTE = POS_ROUTE + "/marketing/campaigns"